import { INIT_PAGE_STATE } from "../../constant/constant";
import {
  IMPORT_LOG_GET_LIST,
  IMPORT_LOG_GET_LIST_SUCCESS,
  IMPORT_LOG_GET_LIST_ERROR,
  SET_IMPORT_LOG_ID,
} from "./actions";

const INIT_STATE = {
  list: {
    data: null,
    loading: false,
    error: false,
    filter: null,
    deleteFlag: null,
    orderBy: "id",
    sortedBy: "asc",
    message: null,
    page: INIT_PAGE_STATE,
  },
};

const importLogReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case IMPORT_LOG_GET_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
          filter: action.payload.filter,
          deleteFlag: action.payload.deleteFlag,
          orderBy: action.payload.orderBy,
          sortedBy: action.payload.sortedBy,
        },
      };

    case IMPORT_LOG_GET_LIST_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          data: action.payload.data.map((t) => {
            return {
              ...t,
              id: Number(t.id),
              ...t.attributes,
            };
          }),
          page: {
            ...state.list.page,
            currentPage: action.payload.meta.pagination.current_page,
            selectedPageSize: action.payload.meta.pagination.per_page,
            totalItem: action.payload.meta.pagination.total_item,
            totalPage: action.payload.meta.pagination.total_page,
            itemCount: action.payload.meta.pagination.item_count,
          },
          loading: false,
          error: false,
          message: null,
        },
      };
    }

    case IMPORT_LOG_GET_LIST_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          data: null,
          loading: false,
          error: true,
          page: INIT_PAGE_STATE,
          message: action.payload,
        },
      };

    case SET_IMPORT_LOG_ID:
      localStorage.setItem("importLogData", JSON.stringify(action.payload));
      return state;

    default:
      return state;
  }
};

export default importLogReducer;
